import React from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import {
  FaBolt,
  // FaDisplay,
  FaBatteryFull,
  FaShieldAlt,
  FaLeaf,
  FaApple,
  FaArrowRight,
  FaTv,
} from "react-icons/fa";
import "./introduce.css";

const features = [
  {
    number: "01",
    icon: <FaBolt />,
    title: "Blazing Fast Performance",
    description:
      "Next-gen Apple M5 chip and optimized software deliver lightning speed for any task.",
  },
  {
    number: "02",
    icon: <FaTv />,
    title: "Stunning Visuals",
    description:
      "Nano-Texture Glass and Retina displays bring every detail to life with true-to-life colors.",
  },
  {
    number: "03",
    icon: <FaBatteryFull />,
    title: "All-Day Battery",
    description:
      "Work, create, and play without worrying about charging - up to 20 hours of power.",
  },
  {
    number: "04",
    icon: <FaShieldAlt />,
    title: "Privacy First",
    description:
      "Built-in security features keep your data safe, both online and offline.",
  },
  {
    number: "05",
    icon: <FaLeaf />,
    title: "Eco-Friendly",
    description: "Made with 100% recycled aluminum and responsible materials.",
  },
  {
    number: "06",
    icon: <FaApple />,
    title: "Seamless Ecosystem",
    description:
      "Works perfectly with iPhone, Apple Watch, and all your Apple devices.",
  },
];

const Introduce = () => {
  return (
    <section className="why-choose-us">
      <div className="container">
        {/* Section Header */}
        <motion.div
          className="section-header-intro"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <span className="why-label">
            {/* <span className="why-label-dot"></span> */}
            WHY CHOOSE US
          </span>

          <h2>
            Technology that
            {/* <br /> */}
            <span>moves you forward.</span>
          </h2>

          <p>
            Thoughtfully designed innovation, powerful performance, and
            effortless experiences - all working together.
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div
              key={feature.number}
              className="feature-card"
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: index * 0.08 }}
              viewport={{ once: true }}
              whileHover={{ y: -7 }}
            >
              <div className="feature-card-top">
                <div className="feature-icon">{feature.icon}</div>
                <span className="feature-number">{feature.number}</span>
              </div>

              <div className="feature-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>

              <div className="feature-bottom-line"></div>
            </motion.div>
          ))}
        </div>

        {/* CTA Banner */}
        <motion.div
          className="cta-banner"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <div className="cta-decoration cta-decoration-one"></div>
          <div className="cta-decoration cta-decoration-two"></div>

          <div className="cta-text">
            <span className="cta-eyebrow">YOUR NEXT UPGRADE STARTS HERE</span>
            <h3>
             Pre Book iPhone 18 Series Now
              <br />
              {/* <span>extraordinary?</span> */}
            </h3>
            <p>
              Explore our latest collection and discover the perfect device for
              the way you live and work.
            </p>
          </div>

          <div className="cta-action">
            <NavLink to="/pre-booking" className="cta-button">
              Pre Book Now
              <span className="cta-arrow">
                <FaArrowRight />
              </span>
            </NavLink>
            <span className="cta-caption">Discover what's possible.</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Introduce;
